<div class="fs-container">
  <mat-dialog-content>
    <sn-google-map [zoom]="19" (mapInit)="onMapInit($event)" [center]="googleMapCenter">
    </sn-google-map>
    <div id="pano"></div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <sn-flat-button mat-dialog-close>{{ 'common.close' | t }}</sn-flat-button>
    <div *ngIf="this.canEdit">
      <sn-flat-button (click)="saveCameraHeading()">{{ 'cameras.streetView.saveCameraHeading' | t }}</sn-flat-button>
      <sn-flat-button (click)="saveCameraLocation()">{{ 'cameras.streetView.saveCameraLocation' | t }}</sn-flat-button>
    </div>
  </mat-dialog-actions>
</div>
